import { get } from './httpRequest';

// eslint-disable-next-line import/prefer-default-export
export const fetchFloats = async ({ tillId, from, to }) => {
  const suffix = from && to ? `?from=${from}&to=${to}` : '';
  const response = await get(`/floats/${tillId}${suffix}`);
  return response.data;
};
